import { useMemo } from "react";
const POPPER_DATA_TEST_IT = "multiselect-option-container";
const POPUP_INDICATOR_DATA_TEST_IT = "multiselect-show-hide-button";
function useComponentsProps(providedComponentsProps) {
  return useMemo(
    () => ({
      ...providedComponentsProps,
      ...{
        popper: {
          ...providedComponentsProps?.popper,
          componentsProps: {
            ...providedComponentsProps?.popper?.componentsProps,
            root: {
              "data-testid": POPPER_DATA_TEST_IT,
              ...providedComponentsProps?.popper?.componentsProps?.root
            }
          }
        },
        popupIndicator: {
          "data-testid": POPUP_INDICATOR_DATA_TEST_IT,
          ...providedComponentsProps?.popupIndicator
        }
      }
    }),
    [providedComponentsProps]
  );
}
export {
  useComponentsProps
};
//# sourceMappingURL=useComponentsProps.js.map
